import {
    CREATE_CLIP_REQUEST_GET_REQUEST,
    CREATE_CLIP_REQUEST_GET_RESULT,
    CREATE_CLIP_REQUEST_OPEN_MODAL,
    CREATE_CLIP_REQUEST_REQUEST,
    CREATE_CLIP_REQUEST_RESULT
} from 'Redux/actionTypes';

export const createClipRequestGetRequest = (data) => ({
    type: CREATE_CLIP_REQUEST_GET_REQUEST,
    payload: data
})

export const createClipRequestGetResult = (data) => ({
    type: CREATE_CLIP_REQUEST_GET_RESULT,
    payload: data
})

export const createClipRequestOpenModal = (data) => ({
    type: CREATE_CLIP_REQUEST_OPEN_MODAL,
    payload: data
})


export const createClipRequestRequest = (data) => ({
    type: CREATE_CLIP_REQUEST_REQUEST,
    payload: data
})

export const createClipRequestResult = (data) => ({
    type: CREATE_CLIP_REQUEST_RESULT,
    payload: data
})